import React from "react";

export const YoutubeLogo: React.FC<{}> = () => (
    <svg  viewBox="0 0 35 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.5 18.1487C0.5 22.1905 3.76739 25.4668 7.79628 25.4668H27.1549C31.1849 25.4668 34.4525 22.1905 34.4525 18.1487V7.85149C34.4525 3.81098 31.1849 0.533447 27.1549 0.533447H7.79628C3.76739 0.533447 0.5 3.81098 0.5 7.85149V18.1487ZM12.7273 17.7475V8.26992C12.7273 8.04614 12.9113 7.88304 13.1134 7.88302C13.1712 7.88302 13.2305 7.89635 13.2873 7.92541L22.8942 12.8081C23.1802 12.9533 23.1748 13.3638 22.8864 13.501L13.2793 18.0973C13.0237 18.22 12.7273 18.0326 12.7273 17.7475Z" fill="currentColor"/>
    </svg>
);
